export enum QuestionnaireLanguage {
  En = "en",
  No = "no",
}
